import React, { Component } from 'react'
import * as actions from "../actions";
import * as utils from "../../utils";

import FeedReplies from "../../posts/components/feed-replies";
import ReplyForm from "../../posts/components/reply-form";
import SlideshowSideAd from "./slideshow-side-ad";

const SlideshowComments = React.createClass({
  componentWillUpdate() {
    this.commentPadding = this.getCommentPadding();
  },
  componentDidMount() {
    if (this.commentsPanel) {
      this.commentsPanel.style.paddingTop = this.getCommentPadding() + "px";
    }
  },
  getCommentPadding() {
    if (document.getElementById('title-wrap')) {
      return document.getElementById('title-wrap').clientHeight + 16;
    } else {
      return 0;
    }
  },
  componentDidUpdate(prevProps, prevState) {
    if (prevProps.post && this.props.post.id === prevProps.post.id) {
      const replyCount = this.props.post.replies.total_count;
      const prevReplyCount = prevProps.post.replies.total_count;
      if (replyCount == prevReplyCount + 1) {
        this.scrollCommentsToBottom();
      }
    } else {
      this.scrollCommentsToBottom();
    }
  },
  render() {
    const post = this.props.post;
    if (!post) {
      return null;
    }
    const { replies, id } = post;
    const canComment = utils.canComment();
    const replyCount = post.replies.total_count;
    const noReplies = replyCount === 0;
    const showAd = !utils.isMobile() && !utils.isPremium();
    const suggestionsOnTop = utils.isMobile();
    return (
      <div
        className="comments-panel"
        style={{paddingTop: this.commentPadding + "px"}}
        ref={(c) => this.commentsPanel = c}
      >
        <div className="mobile-comment-heading">
          <h3>
            Comments
            { replyCount > 0 &&
              <span>&nbsp;({replyCount})</span>
            }
          </h3>
          <i className="icon-cancel" onClick={this.handleCommentClose}></i>
        </div>
        <div className="slideshow-comments-wrap" ref="slideshowReplies">
          { canComment && noReplies &&
            <NoCommentsNotice />
          }
          { !canComment && noReplies &&
            <RsvpToReplyNotice />
          }
          <div className="reply-container">
            <FeedReplies replies={post.replies} postId={post.id} onReplyClick={this.handleReplyButtonClick}/>
          </div>
        </div>
        { canComment &&
          <ReplyForm
            postId={post.id}
            buttonVisible={true}
            suggestionsOnTop={suggestionsOnTop}
            ref={(c) => {this.replyForm = c;} }
          />
        }
        { showAd &&
          <SlideshowSideAd postId={post.id} />
        }
      </div>
    )
  },
  handleReplyButtonClick: function(event, reply) {
    this.replyForm && this.replyForm.replyToReply(reply);
  },
  handleCommentClose(e) {
    actions.hideSlideshowComments();
  },
  scrollCommentsToBottom() {
    const node = this.refs.slideshowReplies;
    node.scrollTop = node.scrollHeight;
  }
});

function NoCommentsNotice() {
  return (
    <em>No comments yet - be the first!</em>
  )
}

function RsvpToReplyNotice() {
  return (
    <em>You must RSVP first to post a reply</em>
  )
}

export default SlideshowComments;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/slideshow/components/slideshow-comments.es6